<div class="wrapper">

  <section id="banner-destinos" class="banner-container hero is-medium banner-header-destinos top-area" aria-label="Montreal Viagens - Rio de Janeiro">
    <div class="hero-body bg-hoteis-destinos">
      <div class="container">
        <div class="area-breadcrumb">
          <nav class="breadcrumb">
            <ul>
              <li><a href="/"><strong>Home</strong></a></li>
              <span><i class="fas fa-chevron-right"></i></span>
              <li>Destinos</li>
            </ul>
          </nav>
        </div>
        <div class="espacamento-esquerda">
          <h1 class="title has-text-white">Destinos para sua <br>próxima viagem</h1>
          <app-busca-hoteis></app-busca-hoteis>
        </div>
      </div>
    </div>
    <small class="has-text-white" style="text-align: end; padding-right: 0.8em">Rio de Janeiro - RJ</small>
  </section>


  <section id="destinos">

    <div class="container is-fluid categoria-hotel">
<!--      <div class="area-step-category">-->
<!--        <div class="step-one">-->
<!--          <h3 class="subtitle">O que você deseja?</h3>-->
<!--          <div class="item-check icon-praia cursor-pointer"><a routerLink="/busca-hoteis"-->
<!--              [queryParams]="{ tipoComodidade:23 }"><i class="fas fa-sun"></i><span>Praia</span></a></div>-->
<!--          <div class="item-check icon-luxo cursor-pointer"><a routerLink="/busca-hoteis"-->
<!--              [queryParams]="{ tipoApartamento:[3,14] }"><i class="fas fa-gem"></i><span>Luxo</span></a></div>-->
<!--          <div class="item-check icon-relaxar cursor-pointer"><a routerLink="/busca-hoteis"-->
<!--              [queryParams]="{ tipoComodidade:24 }"><i class="fas fa-spa"></i><span>Relaxar</span></a></div>-->

<!--          <div class="item-check icon-natureza cursor-pointer"><a routerLink="/busca-hoteis"-->
<!--              [queryParams]="{ tipoComodidade:19 }"><i class="fas fa-mountain"></i><span>Natureza</span></a></div>-->
<!--        </div>-->
<!--      </div>-->

      <div class="column-destinos">
        <h3 class="title top">Destinos</h3>
<!--        <p>-->
<!--          Você escolhe o plano que mais combina com você e adquire diárias gastando menos<br>-->
<!--          do que reservando por sites ou diretamente com o hotel. Quando for viajar,-->
<!--          é só escolher o <br>-->
<!--          destino, buscar o hotel ideal e reservar!-->
<!--        </p>-->
        <p>
          Conheça os melhores destinos do Brasil com uma Assinatura de Hotéis da Montreal
          <br>
          Viagens! Hospede-se em cidades maravilhosas e curta muito seu próximo descanso.
        </p>
      </div>


      <div class="itens-destinos" *ngIf="resultHoteis">
        <div class="tile is-ancestor">

          <div class="tile is-vertical is-3">
            <div class="tile">
              <div class="tile is-parent is-vertical">
                <article class="tile is-child notification is-primary"
                  [style.backgroundImage]="'url('+ resultHoteis.destinos[0].imagem +')'"
                         style="background-size: cover;" [attr.aria-label]="resultHoteis.destinos[0].alt">
                  <a (click)="irParaDestino(resultHoteis.destinos[0].slug)">
                    <div class="img-overlay"></div>
                    <div class="footer">
                      <p class="title">{{resultHoteis.destinos[0].titulo}} </p>
                      <p class="subtitle"><i class="fas fa-map-marker"></i> {{resultHoteis.destinos[0].estado}}</p>
                      {{resultHoteis.destinos[0].resumo}}
                    </div>
                  </a>
                </article>
                <article class="tile is-child notification is-primary"
                  [style.backgroundImage]="'url('+ resultHoteis.destinos[10].imagem +')'"
                  style="background-size: cover;" [attr.aria-label]="resultHoteis.destinos[10].alt">
                  <a (click)="irParaDestino(resultHoteis.destinos[10].slug)">
                    <div class="img-overlay"></div>
                    <div class="footer">
                      <p class="title">{{resultHoteis.destinos[10].titulo}} </p>
                      <p class="subtitle"><i class="fas fa-map-marker"></i> {{resultHoteis.destinos[10].estado}}</p>
                      {{resultHoteis.destinos[10].resumo}}
                    </div>
                  </a>
                </article>
              </div>
            </div>
          </div>

          <div class="tile is-vertical is-3">
            <div class="tile">
              <div class="tile is-parent is-vertical">
                <article class="tile is-child notification is-primary"
                  [style.backgroundImage]="'url('+ resultHoteis.destinos[1].imagem +')'"
                  style="background-size: cover;" [attr.aria-label]="resultHoteis.destinos[1].alt">
                  <a (click)="irParaDestino(resultHoteis.destinos[1].slug)">
                    <div class="img-overlay"></div>
                    <div class="footer">
                      <p class="title">{{resultHoteis.destinos[1].titulo}} </p>
                      <p class="subtitle"><i class="fas fa-map-marker"></i> {{resultHoteis.destinos[1].estado}}</p>
                      {{resultHoteis.destinos[1].resumo}}
                    </div>
                  </a>
                </article>
                <article class="tile is-child notification is-primary"
                  [style.backgroundImage]="'url('+ resultHoteis.destinos[2].imagem +')'"
                  style="background-size: cover;" [attr.aria-label]="resultHoteis.destinos[2].alt">
                  <a (click)="irParaDestino(resultHoteis.destinos[2].slug)">
                    <div class="img-overlay"></div>
                    <div class="footer">
                      <p class="title">{{resultHoteis.destinos[2].titulo}} </p>
                      <p class="subtitle"><i class="fas fa-map-marker"></i> {{resultHoteis.destinos[2].estado}}</p>
                      {{resultHoteis.destinos[2].resumo}}
                    </div>
                  </a>
                </article>
              </div>
            </div>
          </div>
          <div class="tile is-vertical is-6">
            <div class="tile">
              <div class="tile is-parent is-vertical">
                <article class="tile is-child notification is-primary"
                  [style.backgroundImage]="'url('+ resultHoteis.destinos[3].imagem +')'"
                  style="background-size: cover;" [attr.aria-label]="resultHoteis.destinos[3].alt">
                  <a (click)="irParaDestino(resultHoteis.destinos[3].slug)">
                    <div class="img-overlay"></div>
                    <div class="footer">
                      <p class="title">{{resultHoteis.destinos[3].titulo}} </p>
                      <p class="subtitle"><i class="fas fa-map-marker"></i> {{resultHoteis.destinos[3].estado}}</p>
                      {{resultHoteis.destinos[3].resumo}}
                    </div>
                  </a>
                </article>
                <article class="tile is-child notification is-primary"
                  [style.backgroundImage]="'url('+ resultHoteis.destinos[4].imagem +')'"
                  style="background-size: cover;" [attr.aria-label]="resultHoteis.destinos[4].alt">
                  <a (click)="irParaDestino(resultHoteis.destinos[4].slug)">
                    <div class="img-overlay"></div>
                    <div class="footer">
                      <p class="title">{{resultHoteis.destinos[4].titulo}} </p>
                      <p class="subtitle"><i class="fas fa-map-marker"></i> {{resultHoteis.destinos[4].estado}}</p>
                      {{resultHoteis.destinos[4].resumo}}
                    </div>
                  </a>
                </article>
              </div>
            </div>
          </div>
        </div>
        <div class="tile is-ancestor">
          <div class="tile is-vertical is-3">
            <div class="tile">
              <div class="tile is-parent is-vertical">
                <article class="tile is-child notification is-primary"
                  [style.backgroundImage]="'url('+ resultHoteis.destinos[5].imagem +')'"
                  style="background-size: cover;" [attr.aria-label]="resultHoteis.destinos[5].alt">
                  <a (click)="irParaDestino(resultHoteis.destinos[5].slug)">
                    <div class="img-overlay"></div>
                    <div class="footer">
                      <p class="title">{{resultHoteis.destinos[5].titulo}} </p>
                      <p class="subtitle"><i class="fas fa-map-marker"></i> {{resultHoteis.destinos[5].estado}}</p>
                      {{resultHoteis.destinos[5].resumo}}
                    </div>
                  </a>
                </article>
                <article class="tile is-child notification is-primary"
                  [style.backgroundImage]="'url('+ resultHoteis.destinos[6].imagem +')'"
                  style="background-size: cover;" [attr.aria-label]="resultHoteis.destinos[6].alt">
                  <a (click)="irParaDestino(resultHoteis.destinos[6].slug)">
                    <div class="img-overlay"></div>
                    <div class="footer">
                      <p class="title">{{resultHoteis.destinos[6].titulo}} </p>
                      <p class="subtitle"><i class="fas fa-map-marker"></i> {{resultHoteis.destinos[6].estado}}</p>
                      {{resultHoteis.destinos[6].resumo}}
                    </div>
                  </a>
                </article>
              </div>
            </div>
          </div>
          <div class="tile is-parent is-6">
            <article class="tile is-child notification is-success"
              [style.backgroundImage]="'url('+ resultHoteis.destinos[7].imagem +')'" style="background-size: cover;" [attr.aria-label]="resultHoteis.destinos[7].alt">
              <a (click)="irParaDestino(resultHoteis.destinos[7].slug)">
                <div class="img-overlay"></div>
                <div class="footer">
                  <p class="title">{{resultHoteis.destinos[7].titulo}}</p>
                  <p class="subtitle"><i class="fas fa-map-marker"></i> {{resultHoteis.destinos[7].estado}}</p>
                  {{resultHoteis.destinos[7].resumo}}
                </div>
              </a>
            </article>
          </div>
          <div class="tile is-vertical is-3">
            <div class="tile">
              <div class="tile is-parent is-vertical">
                <article class="tile is-child notification is-primary"
                  [style.backgroundImage]="'url('+ resultHoteis.destinos[8].imagem +')'"
                  style="background-size: cover;" [attr.aria-label]="resultHoteis.destinos[8].alt">
                  <a (click)="irParaDestino(resultHoteis.destinos[8].slug)">
                    <div class="img-overlay"></div>
                    <div class="footer">
                      <p class="title">{{resultHoteis.destinos[8].titulo}} </p>
                      <p class="subtitle"><i class="fas fa-map-marker"></i> {{resultHoteis.destinos[8].estado}}</p>
                      {{resultHoteis.destinos[8].resumo}}
                    </div>
                  </a>
                </article>
                <article class="tile is-child notification is-primary"
                  [style.backgroundImage]="'url('+ resultHoteis.destinos[9].imagem +')'"
                  style="background-size: cover;" [attr.aria-label]="resultHoteis.destinos[9].alt">
                  <a (click)="irParaDestino(resultHoteis.destinos[9].slug)">
                    <div class="img-overlay"></div>
                    <div class="footer">
                      <p class="title">{{resultHoteis.destinos[9].titulo}} </p>
                      <p class="subtitle"><i class="fas fa-map-marker"></i> {{resultHoteis.destinos[9].estado}}</p>
                      {{resultHoteis.destinos[9].resumo}}
                    </div>
                  </a>
                </article>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section id="montreal-hoteis" class="section">
    <div class="container is-fluid">
      <div class="columns">
        <div class="column is-12">
          <h1>Hotéis</h1>
          <p>
            Hotéis selecionados por uma curadoria especializada! Sua hospedagem perfeita
            <br>
            em pagamentos mensais é com a gente.
          </p>

        </div>
      </div>


      <div class="columns" *ngIf="premiumList && premiumList.length > 0">
        <div class="column" *ngFor="let hotel of premiumList.slice(0,3)">
          <div class="item-hotel small-hotel">
            <div class="bg-hotel" [style.backgroundImage]="'url('+ hotel.fotos[0] +')'" [attr.aria-label]="hotel.alt"></div>
            <div class="overlay-img"></div>
            <a (click)="navegarParaDetalheHotel(hotel)">
              <div class="description-hotel">
                <h3 class="h3-title">{{hotel.nome}}</h3>
                <p>{{hotel.cidade}}, {{hotel.uf}}</p>
              </div>
              <div class="footer-hotel">
                <div class="columns">
                  <div class="column">
                    <small>{{hotel.descricao ? hotel.descricao.substring(0,350) : hotel.descricao}}</small>
                  </div>
                </div>
                <div class="columns column-price">
                  <div class="column is-5">
                    <p class="preco-diaria" *ngIf="hotel.valorDiariaHotel"><strong>Diária<br>R$
                        <del>{{hotel.valorDiariaHotel ? hotel.valorDiariaHotel : 0}}*</del></strong></p>
                  </div>
                  <div class="column has-text-right area-btn-diarias">
                    <button href="#" class="btn btn-common">Saiba Mais
                    </button>
                  </div>
                </div>
              </div>
            </a>
          </div>
        </div>
      </div>

      <div class="columns">
        <div class="column text-center">
          <a class="link-all link-bold" routerLink="/busca-hoteis"><span>Todos os hotéis</span></a>
        </div>
      </div>
    </div>
  </section>

  <app-tabela-diarias-facilita></app-tabela-diarias-facilita>

    <app-new-footer></app-new-footer>
</div>
